import { ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCart } from "@/contexts/CartContext";

export function CartIcon() {
  const { state } = useCart();

  return (
    <div className="relative">
      <Link to="/carrinho">
        <Button variant="ghost" size="icon" className="relative rounded-full bg-muted hover:bg-muted/80">
          <ShoppingCart className="h-5 w-5" />
          {state.itemCount > 0 && (
            <Badge 
              variant="destructive" 
              className="absolute -top-1 -right-1 h-5 w-5 text-xs p-0 flex items-center justify-center rounded-full"
            >
              {state.itemCount > 99 ? '99+' : state.itemCount}
            </Badge>
          )}
        </Button>
      </Link>
    </div>
  );
}